import { Component } from '@angular/core';

@Component({
  selector: 'app-request-cpe',
  templateUrl: './request-cpe.component.html',
  standalone: false,
})
export class RequestCpeComponent {}
